import React, { Component } from 'react';
import { Form, Input, Spin } from 'antd';
import { UploadImageV2 } from 'components';
import { connect } from 'react-redux';
import {
  Container,
  PrimaryButtonV2,
  formLayout,
  formValidateMessages,
  H1,
  H2,
  FormWrapper,
  SpaceBetween,
  SecondaryButton,
  convertUrlsToFiles,
  AddSaveHint,
} from 'utils';
import PropTypes from 'prop-types';
import pickBy from 'loadsh/pickBy';
import identity from 'loadsh/identity';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { ProjectsActions } from 'redux/actions';
const FormItem = Form.Item;

class Media extends Component {
  static propTypes = {
    updateDraft: PropTypes.func.isRequired,
    updateDraftAndImages: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    projectId: PropTypes.string,
    currentStep: PropTypes.number.isRequired,
    setCanMove: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    selectedStep: PropTypes.number.isRequired,
    setSubmitFromModal: PropTypes.func.isRequired,
    handleExitEditForm: PropTypes.func,
    editProject: PropTypes.bool,
  };

  state = {
    bannerImage: null,
    outerImage: [],
    images: [],
    mobileImage: null,
    mobileImagesArray: null,
    showErrors: false,
  };
  // setBannerImage = (image) => this.setState({ bannerImage: image });
  setOuterImage = (image) => {
    const currentImages = this.state.images || [];

    let updatedImages = currentImages;
    if (
      image[0] &&
      (!currentImages.length || currentImages[0].uid !== image[0].uid)
    ) {
      updatedImages = [image[0], ...currentImages];
    }

    this.setState({
      outerImage: image.length ? image : [],
      images: updatedImages,
    });
  };
  //this.setState((prevState) => {
  //  const newOuterImage = image.length ? image : null;
  //  const newImages = newOuterImage ? prevState.images : [newOuterImage, ...prevState.images];
  //  return { outerImage: newOuterImage, images: newImages };
  //});
  //};
  setMobileImage = (image) =>
    this.setState({ mobileImage: image.length ? image : [] });
  setImages = (images, remove = false) => {
    const imageList = images.length ? images : [];

    const newOuterImage = [imageList?.[0]] || [];
    const currentOuterImage = this.state.outerImage;

    const outerImageChanged =
      !currentOuterImage[0] ||
      remove ||
      currentOuterImage.uid !== newOuterImage.uid;

    this.setState({
      images: imageList,
      outerImage: outerImageChanged ? newOuterImage : currentOuterImage,
    });
  };
  //setImages = (image) => {
  //  this.setState((prevState) => {
  //    const prevImages = prevState.image;
  //    const newImages = image.length ? (prevImages ? [image, ...prevImages] : [image]) : [];
  //    let newOuterImage = prevState.outerImage;
  //    if (!newOuterImage && newImages.length) {
  //      newOuterImage = newImages[0];
  //    }
  //    return { outerImage: newOuterImage, images: newImages };
  //  });
  //};
  setMobileImages = (image) =>
    this.setState({ mobileImagesArray: image.length ? image : null });

  onFinish = (values) => {
    const { outerImage, images, editProject } = this.state;
    const {
      updateDraftAndImages,
      projectId,
      currentStep,
      setCanMove,
      showModal,
      selectedStep,
      setSubmitFromModal,
    } = this.props;
    const formData = new FormData();

    // if(bannerImage[0].thumbUrl){
    //   formData.append(
    //     'project[banner]',
    //     bannerImage[0].originFileObj,
    //     bannerImage[0].name
    //   );
    // }

    if (!outerImage || !outerImage[0]) {
      this.setState({ showErrors: true });
      return;
    }

    if (outerImage[0].thumbUrl) {
      formData.append(
        'project[outer_image]',
        outerImage[0].originFileObj,
        outerImage[0].name
      );
    }

    let existingImageUrls;

    if (images) {
      existingImageUrls = images
        .filter((img) => img.url)
        .map((img) => img.url);

        existingImageUrls.forEach((url) => {
          formData.append('project[existing_image_urls][]', url);
        });

      const imgArr = images?.filter((img) => img.originFileObj);

      imgArr.forEach((file) => {
        formData.append('project[images][]', file.originFileObj, file.name);
      });

      //for (let [key, value] of formData.entries()) {
      //  if (value instanceof File) {
      //    console.log(`${key}: File - ${value.name}, type: ${value.type}, full value: ${value}`);
      //  } else {
      //    console.log(`${key}: ${value}`);
      //  }
      //}
    }

    if (showModal) {
      updateDraftAndImages(
        projectId,
        { video: values.video, existingImageUrls: existingImageUrls },
        formData,
        selectedStep - 1
      );
      setSubmitFromModal(false);
    } else {
      updateDraftAndImages(
        projectId,
        { video: values.video },
        formData,
        currentStep
      );
    }

    setCanMove(true);
    if (editProject) this.props.handleSteps(6);
    else this.props.handleSteps(7);
  };

  onReturn = () => {
    if (this.props.editProject) this.props.handleExitEditForm();
    else this.props.handleSteps(5);
  };

  render() {
    const { project, loading, projectId, editProject } = this.props;
    return (
      <Container className="inside-form-container">
        <>
          <Spin spinning={loading}>
            <H1>Medien</H1>
            {!loading && (
              <Form
                {...formLayout}
                name="project-details"
                onFinish={this.onFinish}
                onFinishFailed={() => {
                  this.setState({ showErrors: true });
                }}
                validateMessages={formValidateMessages}
                initialValues={
                  projectId
                    ? project
                      ? pickBy(project.media, identity)
                      : {}
                    : ''
                }
              >
                <div>
                  <H2 style={{ marginBottom: '12' }}>Bilder</H2>
                  <p>
                    Lade aussagekräftige Bilder hoch, um dein Projekt optimal zu
                    präsentieren. Dein Coverbild ist das Erste, was User sehen –
                    wähle es mit Bedacht!
                  </p>

                  <FormWrapper>
                    <>
                      <UploadImageV2
                        multiple={false}
                        label='Coverbild'
                        name={'outer_image'}
                        width={'375'}
                        height={'250'}
                        recommendedSize={'1080 x 720'}
                        setImage={this.setOuterImage}
                        images={this.state.outerImage}
                        showErrors={this.state.showErrors}
                        errorTitle={'Coverbild'}
                        fileList={
                          //project.media &&
                          //project.media.outer_image &&
                          //project.media.outer_image.length > 0
                          //  ? convertUrlsToFiles(project.media.outer_image)
                          null
                        }
                      />

                      <UploadImageV2
                        multiple={true}
                        label={'Weitere Bilder'}
                        name={'images'}
                        setImage={this.setImages}
                        images={this.state.images}
                        width={'150'}
                        height={'100'}
                        fileList={
                          //project.media &&
                          //project.media.images &&
                          //project.media.images.length > 0
                          //  ? convertUrlsToFiles(project.media.images)
                          null
                        }
                      />
                    </>
                  </FormWrapper>
                </div>
                <div>
                  <H2>Video</H2>
                  <p>
                    Ein Video zieht Aufmerksamkeit und bringt dein Projekt zum
                    Leben. Nutze es, um deine Idee authentisch zu präsentieren
                    und Unterstützer zu begeistern. Lade dein Video auf YouTube
                    hoch und füge den Link hier ein.
                  </p>
                  <FormWrapper>
                    <FormItem
                      name="video"
                      label="YouTube-Link"
                      extra="Hinweis: Keine Links zu YouTube-Shorts"
                    >
                      <Input
                        placeholder="Link zu YouTube-Video"
                        style={{ height: '40px', fontSize: '16px' }}
                      />
                    </FormItem>
                  </FormWrapper>
                </div>

                {editProject && <AddSaveHint />}

                <FormItem>
                  <SpaceBetween>
                    <SecondaryButton
                      type="primary"
                      minWidth="120px"
                      onClick={this.onReturn}
                    >
                      {editProject ? (
                        <p>Zurück zur Projektübersicht</p>
                      ) : (
                        <>
                          <ArrowLeftOutlined />
                          <p>Zurück</p>
                        </>
                      )}
                    </SecondaryButton>

                    <PrimaryButtonV2
                      type="primary"
                      htmltype="submit"
                      minWidth="120px"
                      id="submit-button"
                    >
                      {editProject ? (
                        <p>Speichern*</p>
                      ) : (
                        <>
                          <p>Weiter</p>
                          <ArrowRightOutlined />
                        </>
                      )}
                    </PrimaryButtonV2>
                  </SpaceBetween>
                </FormItem>
              </Form>
            )}
          </Spin>
        </>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  const { project, loading, errors, currentStep } = state.projects;
  return {
    currentStep,
    project,
    loading,
    errors,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleSteps: (step) => dispatch(ProjectsActions.handleSteps(step)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Media);
